import {
  GLB_FILE,
  GLB_FILE_FAILURE,
  GLB_FILE_SUCCESS,
} from "../../Actions/types";

const initialState = {
  getLoader: false,
  getData: null,
  getError: false,
};
function glbFileReducer(state = initialState, action) {
  switch (action.type) {
    case GLB_FILE:
      return { ...state, getLoader: true };
    case GLB_FILE_SUCCESS:
      return { ...state, getData: action?.payload, getLoader: false };
    case GLB_FILE_FAILURE:
      return { ...state, getError: true, getLoader: false };

    default:
      return state;
  }
}

export default glbFileReducer;
